/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";
import NavBar from "../../../components/NavBar/NavBar";
import OrderTabV2 from "./Chunks/OrderTabV2";
import SalesTabV3 from "./Chunks/SalesTabV3";
import ImagesTabV2 from "./Chunks/ImagesTabV2";
import ChangeStatusV2 from "./Chunks/ChangeStatusV2";
import EditTrayV2 from "./Chunks/EditTrayV2";
import ImageViewDialogV2 from "./Chunks/ImageViewDialogV2";
import DisputedOrders from "./Chunks/DisputedOrders";
import CompleteDisputedOrder from "./Chunks/CompleteDisputedOrder";
import {
  IsEmpty,
  clearAllCache,
  setCacheBlobFile,
} from "../../../utils/helper";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import ChangeStatusFailedConfirmation from "./Chunks/ChangeStatusFailedConfirmation";
import ChangeStatusDispute from "./Chunks/ChangeStatusDispute";
import SummaryPdfView from "./SummaryPdfView";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    // width: "30%",
    // display: "flex",
    float: "left",
    // justifyContent: "space-between",
    // overFlow: "hidden",
    marginLeft: 10,
    marginRight: 10,
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
  },
  tabsContentContainer: {
    width: "98%",
    // display: "flex",
    justifyContent: "space-between",

    overFlow: "auto",
  },
  tabsContentContainerImages: {
    width: "100%",
    // display: "flex",
    justifyContent: "space-between",

    // overFlow: "auto",
  },
  // tabsContentContainerDetail: {
  //   width: "75%",
  //  // display: "flex",
  //   justifyContent: "space-between",
  //   marginTop: 62,
  //   overFlow: "auto",
  // },
  contentContainerImages: {
    alignItems: "center",
    textAlign: "center",
    width: "98%",
    marginLeft: 5,
    marginRight: 5,
  },
  contentContainerSM: {
    float: "left",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
    backgroundColor: "red",
  },
  contentItemsContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
    marginTop: 4,
  },
  activeButton: {
    // Active button styles
    backgroundColor: "#3F51B5",
    borderColor: "#596dde",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#3F51B5",
      borderColor: "#596dde",
      boxShadow: "none",
    },
  },
});

const BootstrapButton = withStyles({
  root: {
    //boxShadow: '',
    color: "black",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    outline: "none", // added this
    lineHeight: 1.5,
    width: 180,
    // height: 33,
    margin: 10,
    backgroundColor: "#FFFFFF",
    borderColor: "#fff",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#3F51B5",
      color: "#ffff",
      boxShadow: "none",
      outline: "none", // added this
    },
    "&:active": {
      backgroundColor: "#3F51B5 !important",

      color: "#ffff",
      boxShadow: "none",
      outline: "none", // added this
    },
    "&:focus": {
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
      backgroundColor: "#3F51B5 !important",

      color: "#ffff",
      outline: "none", // added this
    },
  },
})(Button);

class C01SupervisorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
      ordersDataLoading: false,
      salesData: [],
      salesDataLoading: false,
      imagesData: [],
      imagesDataLoading: false,
      barcodeData: [],
      barcodeDataLoading: false,
      selectedOrder: {},
      selectedSalesData: {},

      isDownloadImages: false,
      isDownloadPdfImages: false,

      isLoading: false,
      isReload: true,

      boqData: [],

      listOfActivitiesData: [
        { id: 1, label: "Send for Printing" },
        { id: 2, label: "Issue Materials" },
        { id: 3, label: "Arrange Cardboard" },
        { id: 4, label: "Print Barcode" },
        { id: 5, label: "Assign Barcode toa bin" },
      ],

      ordersDataSearchLoading: false,

      openChangeStatusDialog: false,
      selectionData: [],
      selectionDataError: "",

      statusData: [],
      statusDataLoading: false,

      status: "",
      statusError: "",

      remarks: "",
      remarksError: "",

      filterStatus: 1,
      filterStatusError: "",

      selectImageObject: {},
      selectImageIndex: 0,
      isOpenImageViewer: false,

      isNextArrowDisabled: true,
      isBackArrowDisabled: true,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      onConfirmItemStatusLoading: false,
      onCancelItemStatusLoading: false,
      traybarCode: "",
      traybarCodeDisabled: true,
      onScanTrayBarCodeLoading: false,
      sendToQALoading: false,

      selectionTabStatus: [
        // {name:"All",value:0},
        // {name:"PENDING",value:1},
        // {name:"APPROVED",value:2},
        // {name:"CONFIRMED",value:13},
        // {name:"CANCELLED",value:6},
        // {name:"PRINTED",value:9},
        // {name:"FAILED",value:18},
        // {name:"DISPUTED",value:19},
      ],
      activeButtonIndex: 1,
      openEditTrayDialog: false,
      userEmail: "",
      userPassword: "",
      trayBarCodeWithAuthenication: "",
      searchBar: "",
      openChangeStatusConfirmationDialog: false,
      actionTypeId: 0,
      actionTypeFailedId: 0,
      DisputedOrdersData: [],
      openChangeStatusDisputedDialog: false,
      actionTypeDisputedId: 0,
      voucherAmountType: "1",
      voucherPercentage: "",
      voucherAmount: "",
      disputedOrderRemarks: "",
      effectiveVoucherFrom: new Date(),
      effectiveVoucherTo: new Date(),
      accumulatedBarcode: "",
      barcodeTimeout: null,
      orderDisputedItemsWithRemarks: [],
      orderDisputedItemsActionsData: [],
      orderDisputedItemsActionsDataLoading: false,
      orderItemId: 0,
      openPrintDialog: false,
      summaryPdfFile: "",
      color: "",
      traysData: [],
      traysDataLoading: false,
      isForceCancel: false,
      summaryPDFUseEffectCall: false,
      isActionTypeDisputeRetry: 0,
    };
  }

  setEffectiveFrom = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherFrom: formattedDate,
    });
  };

  setEffectiveTo = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherTo: formattedDate,
    });
  };
  componentDidMount() {
    // this.getData(
    //   `/sales/C01SalesOrderDisputeItemsStatusesView`,
    //   "orderDisputedItemsActionsData",
    //   "orderDisputedItemsActionsDataLoading"
    // );
    this.getData(
      `/sales/C01SalesOrderStatusView`,
      "statusData",
      "statusDataLoading"
    );
    this.getOrdersData();
  }

  componentWillUnmount() {
    setTimeout(function () {
      clearAllCache();
    }, 0);
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
      isActionTypeDisputeRetry: 0
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }

    switch (stateName) {
      case "ordersData":
        this.setState({
          selectedOrder: {},
          imagesData: [],
          selectedSalesData: {},
          salesData: [],
          isActionTypeDisputeRetry: 0
        });
        break;
      case "salesData":
        if (res.isSuccess && resData.length > 0) {
          const salesDataObj = resData[0] || {};
          const orderId = !IsEmpty(salesDataObj)
            ? salesDataObj.orderId || 0
            : 0;
          const productId = !IsEmpty(salesDataObj)
            ? salesDataObj.productId || 0
            : 0;
          const jobId = !IsEmpty(salesDataObj) ? salesDataObj.id || 0 : 0;

          this.getImagesAgainstOrderIdAndProductId(
            salesDataObj,
            orderId,
            productId,
            jobId
          );
        }

        break;
      case "statusData":
        if (res.isSuccess && resData.length > 0) {
          const statusDataObj = resData || {};
          const statusData = !IsEmpty(statusDataObj) ? statusDataObj || [] : [];
          this.setState({
            selectionTabStatus: statusData,
            isActionTypeDisputeRetry: 0
          });
        }
        break;
      case "barcodeData":
        if (res.isSuccess && resData.length > 0) {
          localStorage.setItem("ckBarcodeData", JSON.stringify(resData[0]));
          window.open("#/print-summary");
        }
        break;

      case "traybarcodeData":
        if (res.isSuccess && resData.length > 0) {
          this.getSalesData(this.state.selectedOrder.jobId);
        }
        break;

      case "DisputedOrdersData":
        if (res.isSuccess && resData.length > 0) {
          const DisputedOrdersDataObj = resData || {};
          const DisputedOrdersData = !IsEmpty(DisputedOrdersDataObj)
            ? DisputedOrdersDataObj || []
            : [];
          let orderDisputedItemsWithRemarks = [];
          for (let i = 0; i < DisputedOrdersData.length; i++) {
            let obj = {
              actionId: -1,
              orderId: DisputedOrdersData[i].orderId,
              id: DisputedOrdersData[i].id,
              disputeId: DisputedOrdersData[i].disputedId,
              remarks: "",
              voucherAmountType: "",
              voucherPercentage: "",
              voucherAmount: "",
              effectiveFrom: "",
              effectiveTo: "",
              disputeItemRewardType: "1",
              disputeItemReward: "",
            };
            orderDisputedItemsWithRemarks.push(obj);
          }

          this.setState({
            orderDisputedItemsWithRemarks: orderDisputedItemsWithRemarks,
            isActionTypeDisputeRetry: 0
          });
        }
        break;
      default:
        break;
    }

    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  getOrdersData = async (status = "") => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    this.getData(
      `/sales/C01SalesOrderViewV2?statusId=${statusValue}`,
      "ordersData",
      "ordersDataLoading"
    );
  };

  getSalesData = async (jobId) => {
    this.getData(
      `/sales/C01SalesOrderItemsViewV3?jobId=${jobId}&statusId=${this.state.filterStatus}`,
      "salesData",
      "salesDataLoading"
    );
  };

  getSalesDisputedData = async (orderId) => {
    this.getData(
      `/sales/C01SalesOrderDisputedItemsView?orderId=${orderId}&statusId=${this.state.filterStatus}`,
      "DisputedOrdersData",
      "DisputedOrdersDataLoading"
    );
  };

  getSearchResult = async (keyword = "", status = "") => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    // this.getData(
    //   `/sales/C01SalesOrderSearchView?keyword=${keyword}&statusId=${statusValue}`,
    //   "ordersData",
    //   "ordersDataSearchLoading"
    // );
    this.getData(
      `/sales/C01SalesOrderViewV2?keyword=${keyword}&statusId=${statusValue}`,
      "ordersData",
      "ordersDataSearchLoading"
    );
  };

  getImagesData = async (orderId, productId, jobId) => {
    this.getData(
      `/sales/C01SalesOrderItemsImagesViewV2?orderId=${orderId}&productId=${productId}&orderItemId=${jobId}`,
      "imagesData",
      "imagesDataLoading"
    );
  };

  printBarcode = async () => {
    this.getData(
      `/sales/C01SalesOrderItemsImagesBarcodeViewV2?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
      "barcodeData",
      "barcodeDataLoading"
    );
  };

  scanTrayBarcode = async () => {
    this.getData(
      `/sales/C01SalesOrderItemsScanTrayBarCodeView?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
      "traybarcodeData",
      "barcodeDataLoading"
    );
  };

  toggleChangeStatusDialog = (data, actionTypeId) => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      //selectedData: data,
      actionTypeId: actionTypeId,
    });

    // if(actionTypeId==2){
    //   this.onImagesConfirmationClick(2);
    // }else if(actionTypeId==3){
    //   this.onImagesConfirmationClick(3);
    // }
  };

  toggleChangeStatusConfirmationDialog = (actionTypeFailedId) => {
    const { openChangeStatusConfirmationDialog } = this.state;
    this.setState({
      openChangeStatusConfirmationDialog: !openChangeStatusConfirmationDialog,
      actionTypeFailedId: actionTypeFailedId,
    });
  };

  toggleChangeDisputedStatusDialog = (actionTypeId, orderItemId) => {
    const { openChangeStatusDisputedDialog } = this.state;
    this.setState({
      openChangeStatusDisputedDialog: !openChangeStatusDisputedDialog,
      actionTypeDisputedId: actionTypeId,
      orderItemId: orderItemId,
    });
  };

  onDisputeHandleChange = (e) => {
    const { name, value } = e.target;
    if (name == "disputeActionType") {

      const { actionValue, recordId, isComplete } = value;

      if (actionValue == 6) {
        this.setState({
          isActionTypeDisputeRetry: actionValue,
        });
      } else {
        this.setState({
          isActionTypeDisputeRetry: 0,
        });
      }


      let { orderDisputedItemsWithRemarks = [] } = this.state;
      let myIndex = -1;
      if (isComplete == 0) {
        myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.id == recordId
        );

        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[myIndex]["actionId"] = actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }

      } else if (isComplete == 1) {

        myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.disputeId == recordId
        );

        if (myIndex >= 0) {

          orderDisputedItemsWithRemarks[0]["actionId"] = actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }

      }


    } else if (name == "disputeActionRemarks") {
      const { actionValue, recordId, isComplete } = value;
      let { orderDisputedItemsWithRemarks = [] } = this.state;
      if (isComplete == 0) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.id == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[myIndex]["remarks"] = actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      } else if (isComplete == 1) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.disputeId == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[0]["remarks"] = actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      }

    } else if (name == "disputeItemRewardType") {
      const { actionValue, recordId, isComplete } = value;
      let { orderDisputedItemsWithRemarks = [] } = this.state;

      if (isComplete == 0) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.id == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[myIndex]["disputeItemRewardType"] =
            actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      } else if (isComplete == 1) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.disputeId == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[0]["disputeItemRewardType"] =
            actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      }


    } else if (name == "disputeItemReward") {
      const { actionValue, recordId, isComplete } = value;
      let { orderDisputedItemsWithRemarks = [] } = this.state;

      if (isComplete == 0) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.id == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[myIndex]["disputeItemReward"] =
            actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      } else if (isComplete == 1) {
        const myIndex = orderDisputedItemsWithRemarks.findIndex(
          (item) => item.disputeId == recordId
        );
        if (myIndex >= 0) {
          orderDisputedItemsWithRemarks[0]["disputeItemReward"] =
            actionValue;
          this.setState({
            orderDisputedItemsWithRemarks,
          });
        }
      }

    }
  };

  onCheckClick = (e, row = {}) => {
    const { checked } = e.target;
    let { ordersData } = this.state;
    const studentIndex = ordersData.findIndex(
      (item) => item.orderId === row.orderId
    );
    ordersData[studentIndex].isChecked = checked;
    this.setState({
      ordersData,
      selectionDataError: "",
    });
  };

  getOrderId = (order) => {
    if (this.state.filterStatus != 19) {
      this.getSalesData(order.jobId);
    } else {
      this.getSalesDisputedData(order.orderId);
    }
    const { isForceCancel } = this.state;
    this.setState({
      selectedOrder: order,
      imagesData: [],
      selectedSalesData: {},
      isForceCancel: !isForceCancel,
    });
  };

  getImagesAgainstOrderIdAndProductId = (sale, orderId, productId, jobId) => {
    this.getImagesData(orderId, productId, jobId);
    this.setState({
      selectedSalesData: sale,
      isActionTypeDisputeRetry: 0
    });
  };

  getTraysData = async (e) => {
    if (!IsEmpty(e)) {
      e.preventDefault();
    }
    await this.getData(
      `/common/C01CommonTraysView`,
      "traysData",
      "traysDataLoading"
    );
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    switch (name) {
      case "filterStatus":
        this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");
        this.getOrdersData(value);

        if (value == 13) {
          this.setState({
            salesData: [],
            salesDataLoading: false,
            imagesData: [],
            imagesDataLoading: false,
            selectedOrder: {},
            selectedSalesData: {},
            traybarCodeDisabled: false,
            searchBar: "",
          });
        } else {
          this.setState({
            salesData: [],
            salesDataLoading: false,
            imagesData: [],
            imagesDataLoading: false,
            selectedOrder: {},
            selectedSalesData: {},
            traybarCodeDisabled: true,
            searchBar: "",
          });
        }

        break;
      case "searchBar":
        this.getSearchResult(value, this.state.filterStatus);
        break;

      case "traybarCode":
        clearTimeout(this.state.barcodeTimeout);

        // Accumulate the barcode characters
        // eslint-disable-next-line no-case-declarations
        const newAccumulatedBarcode =
          this.state.accumulatedBarcode + value.slice(-1); // Get the last character
        this.setState({ accumulatedBarcode: newAccumulatedBarcode });

        // Set a timeout
        // eslint-disable-next-line no-case-declarations
        const newTimeout = setTimeout(() => {
          this.setState({
            traybarCode: newAccumulatedBarcode,
            accumulatedBarcode: "",
            [errName]: "",
            selectionDataError: "",
          });
          this.onFocusOutTrayBarCodeFieldV2(newAccumulatedBarcode);
        }, 400); // Adjust the timeout as needed

        this.setState({ barcodeTimeout: newTimeout });
        break;

      default:
        break;
    }
    if (name != "traybarCode") {
      this.setState({
        [name]: value,
        [errName]: "",
        selectionDataError: "",
      });
    }
  };

  isFormValid = () => {
    let { statusError } = this.state;
    let isValid = true;

    if (!this.state.status) {
      isValid = false;
      statusError = "Please select status";
    } else {
      statusError = "";
    }

    this.setState({
      statusError,
    });

    return isValid;
  };

  onSaveClick = () => {
    if (this.isFormValid()) {
      document.getElementById("btnStatusSubmit").click();
    }
  };

  onFormSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const data = new FormData(e.target);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderSaveStatusV2`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.setState({
        status: "",
        statusError: "",
        remarks: "",
        remarksError: "",
      });
      this.getData(
        `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  onImageClick = (object) => {
    let { imagesData, isNextArrowDisabled, isBackArrowDisabled } = this.state;
    const currentImageIndex = imagesData.findIndex(
      (item) => item.id == object.id
    );

    if (currentImageIndex != -1) {
      if (currentImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      if (currentImageIndex + 1 == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        isNextArrowDisabled = false;
      }
    }

    window.addEventListener(
      "keydown",
      this.handleOnKeyPressedForImageDilog,
      false
    );

    this.setState({
      selectImageObject: object,
      isOpenImageViewer: true,
      selectImageIndex: currentImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleImageViewerToggle = () => {
    const value = this.state.isOpenImageViewer ? false : true;
    this.setState({
      isOpenImageViewer: value,
    });
  };

  handleChangeViewerToggle = (summaryPdfFile) => {
    console.log("summaryPdfFile ===>> " + summaryPdfFile);
    const value = this.state.openPrintDialog ? false : true;
    const pdfUseEffectValue = !this.state.summaryPDFUseEffectCall;
    this.setState({
      openPrintDialog: value,
      summaryPDFUseEffectCall: pdfUseEffectValue,
      summaryPdfFile: summaryPdfFile,
    });
  };

  downloadFile = async (e, fileName) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${fileName}`;

    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      let csvURL = URL.createObjectURL(result.data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName);
      tempLink.click();
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        alert(result.message);
      }
    }
  };

  downloadImagesData = async () => {
    if (this.state.isDownloadImages === false) {
      this.setState({
        isDownloadImages: true,
      });
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesSummaryDownload?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}&orderItemId=${this.state.selectedOrder.jobId}`;
      const fileName = `${this.state.selectedOrder.orderId}-${this.state.selectedSalesData.id}-${this.state.selectedSalesData.categoryUserLabel}.pdf`;
      let result = await HttpRequestFileDownload(
        "GET",
        url,
        "authorizeJson",
        fileName
      );

      if (result.isSuccess) {
        let csvURL = URL.createObjectURL(result.data);
        let tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        this.getOrderId(this.state.selectedOrder);
      } else {
        if (result.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          alert(result.message);
        }
      }

      this.setState({
        isDownloadImages: false,
      });
    }
  };

  downloadImagesDataForPrint = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesSummaryDownload?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}&orderItemId=${this.state.selectedOrder.jobId}`;
    const fileName = `${this.state.selectedOrder.orderId}-${this.state.selectedSalesData.id}-${this.state.selectedSalesData.categoryUserLabel}.pdf`;
    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      await setCacheBlobFile(result.data, fileName);
      this.getOrderId(this.state.selectedOrder);
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      }
    }
  };

  downloadPdfImagesData = async () => {
    if (!this.state.isDownloadPdfImages) {
      this.setState({
        isDownloadPdfImages: true,
      });
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesDownloadPdfV2?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`;
      const fileName = `${this.state.selectedOrder.orderId}-${this.state.selectedSalesData.id}-${this.state.selectedSalesData.itemName}.zip`;
      let result = await HttpRequestFileDownload(
        "GET",
        url,
        "authorizeJson",
        fileName
      );

      if (result.isSuccess) {
        let csvURL = URL.createObjectURL(result.data);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
      } else {
        if (result.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          alert(result.message);
        }
      }
      this.setState({
        isDownloadPdfImages: false,
      });
    }
  };

  handleChangeStatusClose = () => {
    // this.toggleChangeStatusDialog();
    this.setState({
      status: "",
      statusError: "",
      remarks: "",
      remarksError: "",
      openChangeStatusDialog: false,
    });
  };

  onNextArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let nextImageIndex = selectImageIndex;

    if (prevImageIndex != -1) {
      nextImageIndex = prevImageIndex + 1;
      if (nextImageIndex == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        if (nextImageIndex + 1 == imagesData.length) {
          isNextArrowDisabled = true;
        } else {
          isNextArrowDisabled = false;
        }
        isBackArrowDisabled = false;
        imageObject = imagesData[nextImageIndex] || {};
      }
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: nextImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  onBackArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let newImageIndex = selectImageIndex;

    if (prevImageIndex != -1 || prevImageIndex != 0) {
      newImageIndex = prevImageIndex - 1;

      if (newImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      isNextArrowDisabled = false;
      imageObject = imagesData[newImageIndex] || {};
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: newImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleCloseImageDialog = () => {
    window.removeEventListener("keydown", this.handleOnKeyPressedForImageDilog);
    this.setState({
      isOpenImageViewer: false,
      selectImageIndex: 0,
      selectImageObject: {},
      isBackArrowDisabled: true,
      isNextArrowDisabled: true,
    });
  };

  handleOnKeyPressedForImageDilog = (event) => {
    switch (event.key) {
      case "ArrowRight":
        if (!this.state.isNextArrowDisabled) {
          this.onNextArrowClick();
        }
        break;
      case "ArrowLeft":
        if (!this.state.isBackArrowDisabled) {
          this.onBackArrowClick();
        }
        break;
      default:
        break;
    }
  };

  onImagesConfirmationClick = async (statusId) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const loadingName =
      statusId == 2
        ? "onConfirmItemStatusLoading"
        : "onCancelItemStatusLoading";

    this.setState({
      [loadingName]: true,
    });
    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("statusId", statusId);
    data.append("remarks", this.state.remarks);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsStatusSaveV2`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Sent to Confirmation Dashboard", "success");

      let resData = [];
      let selectedSalesData = {};
      const endPoint = `/sales/C01SalesOrderItemsViewV2?orderId=${orderId}&statusId=${this.state.filterStatus}`;
      const res2 = await HttpRequest(
        "GET",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endPoint}`,
        null,
        "authorizeJson"
      );
      if (res2.isSuccess) {
        resData = res2.data || [];
        if (resData.length > 0) {
          selectedSalesData = resData.find((item) => item.id == orderItemId);
        }
        this.setState({
          salesData: resData,
          selectedSalesData,
        });
      } else {
        if (res2.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
          });
        } else {
          // this.handleSnackbar(true, res2.message, "error");
        }
      }
      this.getData(
        `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");
      // if (statusId == 3) this.toggleChangeStatusDialog();
      this.setState({
        remarks: "",
        remarksError: "",
      });
      this.handleSnackbar(true, "Updated", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.toggleChangeStatusDialog();
    this.setState({
      [loadingName]: false,
    });
  };

  onFocusOutTrayBarCodeField = () => {
    if (!IsEmpty(this.state.selectedSalesData)) {
      if (!IsEmpty(this.state.traybarCode)) {
        this.onScanTray();
      }
    } else {
      console.log("I LOST FOCUS BUT I DONT HAVE DATA");
    }
  };

  onFocusOutTrayBarCodeFieldV2 = (traybarCode) => {
    if (!IsEmpty(this.state.selectedSalesData)) {
      // this.setState({
      //   traybarCode:traybarCode
      // });
      // if(!IsEmpty(this.state.traybarCode)){
      this.onScanTray(traybarCode);
      //  }
    } else {
      console.log("I LOST FOCUS BUT I DONT HAVE DATA");
    }
  };

  sendToQA = async (actionId) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("statusId", actionId);

    const loadingName = "sendToQALoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemStatusQAFailedSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getData(
        `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");
      if (actionId == 10) {
        this.handleSnackbar(true, "Sent To Printing", "success");
      } else {
        this.handleSnackbar(true, "Sent To QA", "success");
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.handleChangeStatusConfirmationClose();
    this.setState({
      [loadingName]: false,
    });
  };

  onScanTray = async (traybarCode) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const itemAssignedTrayBarCode = IsEmpty(traybarCode) ? "" : traybarCode;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("trayBarCode", itemAssignedTrayBarCode);
    const loadingName = "onScanTrayBarCodeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsAssignTrayBarCodeSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.setState({
        traybarCode: "",
      });

      this.handleSnackbar(true, "Tray Assigned", "success");
      this.getSalesData(orderItemId);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.setState({
          traybarCode: "",
        });

        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  onEditTray = async () => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const itemAssignedTrayBarCode = IsEmpty(
      this.state.trayBarCodeWithAuthenication
    )
      ? ""
      : this.state.trayBarCodeWithAuthenication;

    const userEmail = IsEmpty(this.state.userEmail) ? "" : this.state.userEmail;

    const userPassword = IsEmpty(this.state.userPassword)
      ? ""
      : this.state.userPassword;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("trayBarCode", itemAssignedTrayBarCode);
    data.append("userEmail", userEmail);
    data.append("userPassword", userPassword);

    const loadingName = "onScanTrayBarCodeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsAssignTrayBarCodeEdit`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      const { openEditTrayDialog } = this.state;
      this.setState({
        itemAssignedTrayBarCode: "",
        openEditTrayDialog: !openEditTrayDialog,
        userEmail: "",
        userPassword: "",
      });

      this.handleSnackbar(true, "Tray Changed", "success");
      this.getSalesData(orderItemId);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        console.log("RES  ", res);
        if (res.CODE == 4) {
          this.handleSnackbar(true, res.SYSTEM_MESSAGE, "error");
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  radioButtonHandleChange = (actionId, orderItemId, remarks) => {
    console.log("actionId ===>>> ", actionId);
    console.log("orderItemId ===>>> ", orderItemId);
    console.log("remarks ===>>> ", remarks);

    this.setState({
      orderDisputedItemsWithRemarks:
        this.state.orderDisputedItemsWithRemarks.map((el) =>
          el.orderItemId === orderItemId ? { ...el, actionId, remarks } : el
        ),
    });
    this.handleChangeDisputedStatusClose();
  };

  changeStatusDisputedOrder = async (actionId) => {
    //alert("this.state.disputedOrderRemarks",this.state.disputedOrderRemarks)

    const orderItemId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.jobId;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const disputeId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.disputeId;

    const remarks = IsEmpty(this.state.disputedOrderRemarks)
      ? ""
      : this.state.disputedOrderRemarks;

    console.log(
      "this.state.disputedOrderRemarks",
      this.state.disputedOrderRemarks
    );

    const voucherAmountType = this.state.voucherAmountType;
    const voucherPercentage = this.state.voucherPercentage;
    const voucherAmount = this.state.voucherAmount;
    const effectiveFrom = this.state.effectiveVoucherFrom;
    const effectiveTo = this.state.effectiveVoucherTo;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("disputeId", disputeId);

    data.append("statusId", actionId);
    data.append("remarks", remarks);

    if (actionId == 100) {
      data.append("isPercentage", voucherAmountType);
      data.append("voucherAmount", voucherAmount === "" ? 0 : voucherAmount);
      data.append(
        "voucherPercentage",
        voucherPercentage === "" ? 0 : voucherPercentage
      );

      data.append("effectiveFrom", effectiveFrom);
      data.append("effectiveTo", effectiveTo);
    }

    const loadingName = "changeDisputeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedItemsSave1`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getData(
        `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

      if (actionId == 10) {
        this.handleSnackbar(true, "Accepted", "success");
      } else if (actionId == 0) {
        this.handleSnackbar(true, "Rejected", "success");
      } else if (actionId == 100) {
        this.handleSnackbar(true, "Resolved", "success");
      }

      this.setState({
        disputedOrderRemarks: "",
        DisputedOrdersData: [],
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.handleChangeDisputedStatusClose();
    this.setState({
      [loadingName]: false,
    });
  };

  containsObject = (list) => {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].actionId === -1) {
        return true;
      }
    }

    return false;
  };

  validateData = () => {
    let orderDisputedItemsWithRemarks = [
      ...this.state.orderDisputedItemsWithRemarks,
    ];
    if (!this.containsObject(orderDisputedItemsWithRemarks)) {
      this.changeStatusDisputedOrderV2();
    }
  };
  changeStatusDisputedOrderV2 = async () => {
    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const disputeId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.disputeId;

    const data = new FormData();

    data.append("orderId", orderId);
    data.append("disputeId", disputeId);

    let orderDisputedItemsWithRemarks = [
      ...this.state.orderDisputedItemsWithRemarks,
    ];
    for (let j = 0; j < orderDisputedItemsWithRemarks.length; j++) {
      const remarks = IsEmpty(orderDisputedItemsWithRemarks[j].remarks)
        ? ""
        : orderDisputedItemsWithRemarks[j].remarks;

      const orderItemId = orderDisputedItemsWithRemarks[j].id;

      const actionId = orderDisputedItemsWithRemarks[j].actionId;
      data.append("orderItemId", orderItemId);
      data.append("remarks", remarks);
      data.append("statusId", actionId);
    }

    const loadingName = "changeDisputeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedItemsSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getData(
        `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

      this.handleSnackbar(true, "Submitted", "success");

      this.setState({
        disputedOrderRemarks: "",
        DisputedOrdersData: [],
        orderDisputedItemsWithRemarks: [],
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      [loadingName]: false,
    });
  };

  toggleEditTrayDialog = () => {
    const { openEditTrayDialog } = this.state;
    this.setState({
      openEditTrayDialog: !openEditTrayDialog,
    });
  };
  handleChangeEditTrayClose = () => {
    this.setState({
      openEditTrayDialog: false,
    });
  };

  handleChangeStatusConfirmationClose = () => {
    this.setState({
      openChangeStatusConfirmationDialog: false,
    });
  };

  handleChangePdfClose = () => {
    this.setState({
      openPrintDialog: false,
    });
  };

  setVoucherAmountType = async (e) => {
    await this.setState({
      voucherAmountType: e.target.value,
    });
  };

  handleChangeDisputedStatusClose = () => {
    this.setState({
      openChangeStatusDisputedDialog: false,
    });
  };

  saveDisputeStatus = async (actionTypeId, isComplete) => {
    this.setState({
      isLoading: true,
    });
    const { selectedOrder = {} } = this.state;

    if (!IsEmpty(selectedOrder)) {
      const orderId = selectedOrder.orderId || 0;
      const disputeId = selectedOrder.disputeId || 0;
      // //debugger;
      if (isComplete == 1) {

        if (actionTypeId == 1) {
          const data = new FormData();

          data.append("orderId", orderId);
          data.append("disputeId", disputeId);
          const res = await HttpRequest(
            "POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedDeliveryAgainSave`,
            data,
            "authorize"
          );
          if (res.isSuccess) {
            this.getData(
              `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
              "ordersData",
              ""
            );
            this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

            this.handleSnackbar(true, "Saved", "success");

            this.setState({
              disputedOrderRemarks: "",
              DisputedOrdersData: [],
              orderDisputedItemsWithRemarks: [],
            });
          } else {
            if (res.statusCode === 401) {
              this.setState({
                isLoginMenu: true,
                isReload: false,
              });
            } else {
              this.handleSnackbar(true, res.message, "error");
            }
          }
        } else {
          if (this.isCompleterDisputeFormValid()) {
            const data = new FormData();

            data.append("orderId", orderId);
            data.append("disputeId", disputeId);

            const { orderDisputedItemsWithRemarks = [] } = this.state;
            let orderItemActionId = 0;
            let orderItemRemarks = "";
            let isPercentageReward = 0;
            let rewardValue = "";

            for (let j = 0; j < orderDisputedItemsWithRemarks.length; j++) {

              const orderItemId = orderDisputedItemsWithRemarks[j].id;

              if (j == 0) {
                const remarks = IsEmpty(orderDisputedItemsWithRemarks[j].remarks)
                  ? ""
                  : orderDisputedItemsWithRemarks[j].remarks;



                orderItemRemarks = remarks;



                orderItemActionId = orderDisputedItemsWithRemarks[j].actionId;
                rewardValue =
                  orderDisputedItemsWithRemarks[j].disputeItemReward;
                isPercentageReward =
                  orderDisputedItemsWithRemarks[j].disputeItemRewardType == 2
                    ? 1
                    : 0;
              }



              data.append("orderItemId", orderItemId);
              data.append("orderItemRemarks", orderItemRemarks);
              data.append("orderItemActionId", orderItemActionId);
              data.append("isPercentageReward", isPercentageReward);
              data.append("rewardValue", rewardValue);
            }

            const res = await HttpRequest(
              "POST",
              `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedItemsSave`,
              data,
              "authorize"
            );
            if (res.isSuccess) {
              this.getData(
                `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
                "ordersData",
                ""
              );
              this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

              this.handleSnackbar(true, "Saved", "success");

              this.setState({
                disputedOrderRemarks: "",
                DisputedOrdersData: [],
                orderDisputedItemsWithRemarks: [],
              });
            } else {
              if (res.statusCode === 401) {
                this.setState({
                  isLoginMenu: true,
                  isReload: false,
                });
              } else {
                this.handleSnackbar(true, res.message, "error");
              }
            }
          }
        }

      } else {
        if (actionTypeId == 1) {
          const data = new FormData();

          data.append("orderId", orderId);
          data.append("disputeId", disputeId);
          const res = await HttpRequest(
            "POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedDeliveryAgainSave`,
            data,
            "authorize"
          );
          if (res.isSuccess) {
            this.getData(
              `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
              "ordersData",
              ""
            );
            this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

            this.handleSnackbar(true, "Saved", "success");

            this.setState({
              disputedOrderRemarks: "",
              DisputedOrdersData: [],
              orderDisputedItemsWithRemarks: [],
            });
          } else {
            if (res.statusCode === 401) {
              this.setState({
                isLoginMenu: true,
                isReload: false,
              });
            } else {
              this.handleSnackbar(true, res.message, "error");
            }
          }
        } else {
          if (this.isDisputeFormValid()) {
            const data = new FormData();

            data.append("orderId", orderId);
            data.append("disputeId", disputeId);

            const { orderDisputedItemsWithRemarks = [] } = this.state;

            for (let j = 0; j < orderDisputedItemsWithRemarks.length; j++) {
              const remarks = IsEmpty(orderDisputedItemsWithRemarks[j].remarks)
                ? ""
                : orderDisputedItemsWithRemarks[j].remarks;
              const orderItemId = orderDisputedItemsWithRemarks[j].id;
              const actionId = orderDisputedItemsWithRemarks[j].actionId;
              const disputeItemReward =
                orderDisputedItemsWithRemarks[j].disputeItemReward;
              const disputeItemRewardType =
                orderDisputedItemsWithRemarks[j].disputeItemRewardType == 2
                  ? 1
                  : 0;

              data.append("orderItemId", orderItemId);
              data.append("orderItemRemarks", remarks);
              data.append("orderItemActionId", actionId);
              data.append("isPercentageReward", disputeItemRewardType);
              data.append("rewardValue", disputeItemReward);
            }

            const res = await HttpRequest(
              "POST",
              `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderDisputedItemsSave`,
              data,
              "authorize"
            );
            if (res.isSuccess) {
              this.getData(
                `/sales/C01SalesOrderViewV2?statusId=${this.state.filterStatus}`,
                "ordersData",
                ""
              );
              this.getData(`/sales/C01SalesOrderStatusView`, "statusData", "");

              this.handleSnackbar(true, "Saved", "success");

              this.setState({
                disputedOrderRemarks: "",
                DisputedOrdersData: [],
                orderDisputedItemsWithRemarks: [],
              });
            } else {
              if (res.statusCode === 401) {
                this.setState({
                  isLoginMenu: true,
                  isReload: false,
                });
              } else {
                this.handleSnackbar(true, res.message, "error");
              }
            }
          }
        }
      }



    }
    this.setState({
      isLoading: false,
    });
  };

  isDisputeFormValid = () => {
    let isValid = true;
    let { orderDisputedItemsWithRemarks = [] } = this.state;
    console.log(orderDisputedItemsWithRemarks);
    if (IsEmpty(orderDisputedItemsWithRemarks)) {
      isValid = false;
      this.handleSnackbar(
        true,
        "Please select action and enter remarks of all dispute order items",
        "error"
      );
    } else {
      for (let j = 0; j < orderDisputedItemsWithRemarks.length; j++) {
        const remarks = IsEmpty(orderDisputedItemsWithRemarks[j].remarks)
          ? ""
          : orderDisputedItemsWithRemarks[j].remarks;
        const actionId = orderDisputedItemsWithRemarks[j].actionId;
        const disputeItemReward =
          orderDisputedItemsWithRemarks[j].disputeItemReward;

        if (actionId <= 0) {
          isValid = false;
          this.handleSnackbar(
            true,
            "Please select action of all dispute items",
            "error"
          );
          break;
        } else if (actionId == 3 && !disputeItemReward) {
          isValid = false;
          this.handleSnackbar(
            true,
            "Please enter all reward details with action resolved with reward",
            "error"
          );
          break;
        } else if (!remarks) {
          this.handleSnackbar(
            true,
            "Please mark all dispute item remarks",
            "error"
          );
          isValid = false;
          break;
        }
      }
    }

    return isValid;
  };


  isCompleterDisputeFormValid = () => {
    let isValid = true;
    let { orderDisputedItemsWithRemarks = [] } = this.state;
    console.log(orderDisputedItemsWithRemarks);
    if (IsEmpty(orderDisputedItemsWithRemarks)) {
      isValid = false;
      this.handleSnackbar(
        true,
        "Please select action and enter remarks of all dispute order items",
        "error"
      );
    } else {
      if (orderDisputedItemsWithRemarks.length > 0) {

        // //debugger;
        const remarks = IsEmpty(orderDisputedItemsWithRemarks[0].remarks)
          ? ""
          : orderDisputedItemsWithRemarks[0].remarks;
        const actionId = orderDisputedItemsWithRemarks[0].actionId;
        const disputeItemReward =
          orderDisputedItemsWithRemarks[0].disputeItemReward;

        if (actionId <= 0) {
          isValid = false;
          this.handleSnackbar(
            true,
            "Please select action of all dispute items",
            "error"
          );

        } else if (actionId == 3 && !disputeItemReward) {


          isValid = false;
          this.handleSnackbar(
            true,
            "Please enter all reward details with action resolved with reward",
            "error"
          );

        } else if (!remarks) {
          this.handleSnackbar(
            true,
            "Please mark all dispute item remarks",
            "error"
          );
          isValid = false;

        }
      }
    }

    return isValid;
  };




  render() {
    const salesDataObj = { ...this.state.salesData[0] } || {};
    const myBoqObj = !IsEmpty(salesDataObj)
      ? salesDataObj.boqData[0] || {}
      : {};
    if (!IsEmpty(myBoqObj)) {
      const myBoqObjColumns = myBoqObj.columns;
      const myBoqObjItems = myBoqObj.items;
      if (!IsEmpty(myBoqObjColumns)) {
        console.log("Not EMPTY", myBoqObjColumns);
        console.log("Not EMPTY", myBoqObjItems[0].Color);
        let index = myBoqObjColumns.findIndex((x) => x.name === "Color");
        if (index != -1) {
          myBoqObjItems[0].Color = (
            <div
              style={{
                color: `${myBoqObjItems[0].Color1}`,
                background: `${myBoqObjItems[0].Color1}`,
                width: 30,
              }}
            >
              a
            </div>
          );

          console.log("myBoqObjItems[0].Color", myBoqObjItems[0].Color1);
        }
      } else {
        console.log("EMPTY");
      }
    }

    const { classes } = this.props;
    return (
      <Fragment>
        <NavBar isAuthorize title="Supervisor Dashboard" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form onSubmit={this.onFormSubmit}>
          <input name="statusId" value={this.state.status} type="hidden" />
          <input
            name="orderId"
            value={
              IsEmpty(this.state.selectedOrder)
                ? 0
                : this.state.selectedOrder.orderId
            }
            type="hidden"
          />
          <input name="remarks" value={this.state.remarks} type="hidden" />
          <input
            type="submit"
            style={{ display: "none" }}
            id="btnStatusSubmit"
          />
        </form>

        <ImageViewDialogV2
          downloadFile={(e, fileName) => this.downloadFile(e, fileName)}
          handleClose={() => this.handleCloseImageDialog()}
          open={this.state.isOpenImageViewer}
          data={this.state}
          onNextArrowClick={() => this.onNextArrowClick()}
          onBackArrowClick={() => this.onBackArrowClick()}
        />

        <ChangeStatusV2
          onSaveClick={(actionTypeId) =>
            this.onImagesConfirmationClick(actionTypeId)
          }
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusClose()}
        />

        <EditTrayV2
          onSaveClick={() => this.onEditTray()}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openEditTrayDialog}
          state={this.state}
          handleClose={() => this.handleChangeEditTrayClose()}
        />

        <ChangeStatusFailedConfirmation
          onSaveClick={(failedQaTypeId) => this.sendToQA(failedQaTypeId)}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeStatusConfirmationDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusConfirmationClose()}
        />

        <SummaryPdfView
          open={this.state.openPrintDialog}
          handleClose={() => this.handleChangePdfClose()}
          summaryPdfFile={this.state.summaryPdfFile}
          values={this.state}
          downloadImagesDataForPrint={() => this.downloadImagesDataForPrint()}
        />

        <ChangeStatusDispute
          // onSaveClick={(actionId) =>this.changeStatusDisputedOrder(actionId)}
          onHandleChange={(e) => this.onHandleChange(e)}
          onSaveClick={this.radioButtonHandleChange}
          open={this.state.openChangeStatusDisputedDialog}
          state={this.state}
          handleClose={() => this.handleChangeDisputedStatusClose()}
          setVoucherAmountType={(e) => this.setVoucherAmountType(e)}
          setEffectiveTo={this.setEffectiveTo}
          setEffectiveFrom={this.setEffectiveFrom}
        />

        <div style={{ width: "100%", display: "flex", marginTop: 50 }}>
          <Fragment>
            {!IsEmpty(this.state.selectionTabStatus) &&
              this.state.selectionTabStatus.map((status, index) => {
                return (
                  <>
                    <BootstrapButton
                      key={index}
                      variant="contained"
                      color="primary"
                      className={`${classes.margin} ${index === this.state.activeButtonIndex
                        ? classes.activeButton
                        : ""
                        }`}
                      onClick={() => {
                        const { isForceCancel } = this.state;
                        this.setState({
                          activeButtonIndex: index,
                          isForceCancel: !isForceCancel,
                        });
                        this.onHandleChange({
                          target: { name: "filterStatus", value: status.value },
                        });
                      }}
                    >
                      {
                        status.value == 0 || status.value == 1 || status.value == 2 || status.value == 13
                          ? `${status.name} (${status.count?.orderCount !== undefined ? `O#${status.count.orderCount}, J#${status.count.jobCount}` : status.count})`
                          : `${status.name} (${status.count.orderCount})`
                      }


                    </BootstrapButton>
                  </>
                );
              })}
          </Fragment>
        </div>

        <div
          style={{
            minHeight: window.innerHeight - 120,
            maxHeight: window.innerHeight - 120,
            overflow: "auto",
          }}
          className={classes.tabsContainer}
        >
          <OrderTabV2
            onHandleChange={this.onHandleChange}
            onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
            values={this.state}
            ordersData={this.state.ordersData}
            // textFieldRef={this.textFieldRef}
            getOrderId={(id) => this.getOrderId(id)}
          />
        </div>
        {this.state.filterStatus != 19 ? (
          <>
            <div
              style={{ marginBottom: 10 }}
              className={classes.tabsContentContainer}
            >
              <SalesTabV3
                columns={myBoqObj.columns || []}
                rows={myBoqObj.items || []}
                values={this.state}
                onHandleChange={this.onHandleChange}
                onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
                textFieldRef={this.textFieldRef}
                printBarcode={() => this.printBarcode()}
                downloadImagesData={() => this.downloadImagesData()}
                toggleEditTrayDialog={() => this.toggleEditTrayDialog()}
                handleChangeViewerToggle={(summaryPdfFile) =>
                  this.handleChangeViewerToggle(summaryPdfFile)
                }
                getOrderId={(id) => this.getOrderId(id)}
                getTraysData={(e) => this.getTraysData(e)}
              />
            </div>

            <div className={classes.tabsContentContainerImages}>
              {!IsEmpty(myBoqObj) && (
                <div className={classes.contentContainerImages}>
                  <ImagesTabV2
                    values={this.state}
                    downloadPdfImagesData={() => this.downloadPdfImagesData()}
                    downloadImagesData={() => this.downloadImagesData()}
                    onImageClick={(object) => this.onImageClick(object)}
                    onImagesConfirmationClick={(statusType) =>
                      this.onImagesConfirmationClick(statusType)
                    }
                    toggleChangeStatusDialog={(data, actionId) =>
                      this.toggleChangeStatusDialog(data, actionId)
                    }
                    sendToQA={(actionId) => this.sendToQA(actionId)}
                    toggleChangeStatusConfirmationDialog={(actionId) =>
                      this.toggleChangeStatusConfirmationDialog(actionId)
                    }
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div
            style={{
              minHeight: window.innerHeight - 120,
              maxHeight: window.innerHeight - 120,
              overflow: "auto",
            }}
          >
            {!IsEmpty(this.state.DisputedOrdersData) && (
              <div className={classes.contentContainerImages}>
                {this.state.DisputedOrdersData[0].isCompleteDisputedOrder == 1 ?

                  <CompleteDisputedOrder
                    values={this.state}
                    onDisputeHandleChange={(e) => this.onDisputeHandleChange(e)}
                    downloadPdfImagesData={() => this.downloadPdfImagesData()}
                    downloadImagesData={() => this.downloadImagesData()}
                    onImageClick={(object) => this.onImageClick(object)}
                    onChangeDisputeItemActionRetry={(e) => this.onDisputeHandleChange(e)}
                    rows={this.state.DisputedOrdersData || []}
                    //values={this.state}
                    onImagesConfirmationClick={(statusType) =>
                      this.onImagesConfirmationClick(statusType)
                    }
                    toggleChangeStatusDialog={(data, actionId) =>
                      this.toggleChangeStatusDialog(data, actionId)
                    }
                    handleSnackbar={(open, msg, severity) =>
                      this.handleSnackbar(open, msg, severity)
                    }
                    sendToQA={(actionId) => this.sendToQA(actionId)}
                    saveDisputeStatus={(value1, value2) => this.saveDisputeStatus(value1, value2)}
                    toggleChangeDisputedStatusDialog={(actionId, orderItemId) =>
                      this.toggleChangeDisputedStatusDialog(actionId, orderItemId)
                    }
                  />
                  :
                  <DisputedOrders
                    values={this.state}
                    onDisputeHandleChange={(e) => this.onDisputeHandleChange(e)}
                    downloadPdfImagesData={() => this.downloadPdfImagesData()}
                    downloadImagesData={() => this.downloadImagesData()}
                    onImageClick={(object) => this.onImageClick(object)}
                    onChangeDisputeItemActionRetry={(e) => this.onDisputeHandleChange(e)}
                    rows={this.state.DisputedOrdersData || []}
                    //values={this.state}
                    onImagesConfirmationClick={(statusType) =>
                      this.onImagesConfirmationClick(statusType)
                    }
                    toggleChangeStatusDialog={(data, actionId) =>
                      this.toggleChangeStatusDialog(data, actionId)
                    }
                    handleSnackbar={(open, msg, severity) =>
                      this.handleSnackbar(open, msg, severity)
                    }
                    sendToQA={(actionId) => this.sendToQA(actionId)}
                    saveDisputeStatus={(value) => this.saveDisputeStatus(value)}
                    toggleChangeDisputedStatusDialog={(actionId, orderItemId) =>
                      this.toggleChangeDisputedStatusDialog(actionId, orderItemId)
                    }
                  />


                }



              </div>
            )}
          </div>
        )}

        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={5000}
        />
      </Fragment>
    );
  }
}

C01SupervisorDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C01SupervisorDashboard);
